import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

/**
 * The endpoint's page size. It defaults to 15, and 100 is a hard server-side
 * cap — auth-service clamps anything larger — so a role with more than 100
 * holders truncates silently and would need pagination here.
 */
export const INTERNAL_USERS_PAGE_LIMIT = 100;

/**
 * Role slugs this app queries. Recruiter and AE carry identical claims and
 * differ only for list purposes, so the slug is the whole distinction.
 */
export const InternalUserRoles = {
  DsoManager: 'dso',
  Recruiter: 'recruiter',
};

/**
 * Fetches the holders of an internal role from auth-service.
 *
 * The shared replacement for the hand-edited Remote Config lists: a role query
 * maintains itself as staff join and leave. Both the DSO manager list and the
 * recruiter list come through here.
 *
 * `sortBy: 'first_name'` reproduces the monolith's `.sort({ first_name: 1 })`,
 * so the dropdown order does not change from the lists this replaced.
 *
 * Bearer is added by hand, as the other auth-service callers do, rather than
 * via `getAuthServiceHeaders` — that one throws on an expired token because it
 * does not await its refresh (`__tests__/authHeaders.contract.test.js`).
 *
 * @param {string} role - Role slug, e.g. 'dso' or 'recruiter'
 * @returns {Promise<import('../types/User.api').IGetInternalUsersApiResponse>}
 */
export const getInternalUsersByRole = async (role) => {
  const { Authorization: accessToken } = await getAuthHeaders();

  const response = await tempMeeApi.get('/auth-service/admin/internal-users', {
    params: { role, limit: INTERNAL_USERS_PAGE_LIMIT, sortBy: 'first_name', orderBy: 'asc' },
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  return response.data;
};
